import React, { useState } from "react";

import { BrandLogo } from "icons";

import settingsApi from "apis/settings";
import {
  Avatar,
  Input,
  Button,
  Typography,
  Toastr,
  SubHeader,
} from "clearsense-ui/components";
import { useUserState } from "contexts/user";

import UploadModal from "./UploadModal";
import { validateFile } from "./utils";

const UploadLogo = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [file, setFile] = useState();
  const user = useUserState();

  const handleFileLoaded = file => setFile(file);

  const handleFileUpload = async () => {
    try {
      setIsLoading(true);
      const isValidLogo = validateLogo();
      if (!isValidLogo) return;
      const formData = new FormData();
      formData.append("settings[logo]", file);
      await settingsApi.update(formData);
      Toastr.success("Logo updated successfully");
      setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      logger.error(error);
      Toastr.error("Error while updating logo");
    } finally {
      setIsLoading(false);
      setFile(null);
    }
  };

  const validateLogo = () => {
    const validatedFile = validateFile(file);
    if (validatedFile.error) {
      setErrorMessage(validatedFile.message);
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleRemoveLogo = async () => {
    try {
      setIsLoading(true);
      await settingsApi.deleteLogo();
      Toastr.success("Logo deleted successfully");
      setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      logger.error(error);
      Toastr.error("Error while deleting logo");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pl-8 overflow-hidden">
      <SubHeader
        breadcrumbs={[
          { label: "Settings", link: "#" },
          { label: "Upload Organization Logo", link: "/setting/logo" },
        ]}
        className="mt-8"
      />
      <div className="flex items-center gap-5 mt-5">
        {user.organization_logo_url !== null ? (
          <Avatar
            onClick={{
              onClick: () => {},
            }}
            size="xlarge"
            user={{
              name: "- -",
              imageUrl: user.organization_logo_url,
            }}
            className="mx-2"
          />
        ) : (
          <BrandLogo />
        )}

        <div className="flex flex-col gap-2">
          <Typography
            style="h3"
            type="bold"
            className="text-gray-700 dark:text-cs-ui-gray-500"
            data-cy="upload-logo-heading"
          >
            Upload Logo
          </Typography>
          <Typography style="h5" className="text-gray-500" type="bold">
            Only JPEG and PNG files are supported. Maximum allowed file size
            1MB.
          </Typography>
          <Input
            type="file"
            id="avatar"
            name="avatar"
            accept="image/png, image/jpeg"
            onChange={e => {
              setFile(e.target.files[0]);
            }}
            data-cy="upload-logo-input"
          />
          {errorMessage && (
            <Typography
              className="mt-2 text-sm text-red-600"
              data-cy="upload-logo-error-message"
            >
              {errorMessage}
            </Typography>
          )}
          <div className="flex gap-3 mt-2">
            <Button
              label="Upload Logo"
              style="primary"
              onClick={handleFileUpload}
              loading={isLoading}
              disabled={!file}
              data-cy="upload-logo-button"
            />
            {user.organization_logo_url !== null && (
              <Button
                label="Remove Logo"
                style="secondary"
                onClick={handleRemoveLogo}
                data-cy="remove-logo-button"
              />
            )}
          </div>

          <UploadModal
            showModal={showModal}
            setShowModal={setShowModal}
            handleFileLoaded={handleFileLoaded}
            handleFileUpload={handleFileUpload}
          />
        </div>
      </div>
    </div>
  );
};

export default UploadLogo;
